module.exports = __webpack_public_path__ + "img/pictoEstablishementsCommon1.b5e645d6.svg";